<template>
	<div class="dashboard">
		<v-layout row wrap>
			<v-flex xs12 sm7 md9 class="div-container-dashboard">
				<v-layout row wrap>
					<v-flex xs12 sm12 md12>
						<div class="div-container-selects">
							<div class="div-container-filters">
								<date-range-picker
									:startDate="startDate"
									:endDate="endDate"
									presets="Mmty"
									@select="date_range_select"
								></date-range-picker>
								<select-plus
									label="Anunciantes"
									noDataText="Nenhum anunciante"
									itemName="anunciante"
									:selected="rootSelectedAdvertisers"
									:items="advertiserList"
									v-model="selectedAdvertisers"
									itemText="reg_name"
									returnObject
								/>
							</div>
							<div class="div-container-filters-button">
								<button
									v-if="!loading"
									v-on:click="load_aff_summary"
									class="button-generate-note"
								>
									<v-icon class="material-icons-outlined" size="40">bolt</v-icon>
									<p>Gerar relatório</p>
								</button>
							</div>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap v-if="!loading">
					<v-flex xs12 sm12 md12>
						<div class="div-container-view">
							<div class="div-container-boxOne">
								<div>
									<p class="paragrafo-title">Vendas aprovadas</p>
									<p class="paragrafo-subtitle">Valor de vendas aprovadas</p>
									<p class="paragrafo-price-approved">{{to_reais(affSummaryRaw.purchases_approved_value, 2)}}</p>
								</div>
								<div>
									<p class="paragrafo-title">Pedidos aprovados</p>
									<p class="paragrafo-subtitle">Quantidade de pedidos aprovados</p>
									<p class="paragrafo-price-approved">{{add_thousands_sep(affSummaryRaw.purchases_approved_count)}}</p>
								</div>
							</div>
							<div class="div-container-boxTwo">
								<div>
									<p class="paragrafo-title">Comissão das vendas</p>
									<p class="paragrafo-subtitle">Valor de comissão aprovada</p>
									<p class="paragrafo-price-approved">{{to_reais(affSummaryRaw.purchases_approved_commission, 2)}}</p>
								</div>
								<div>
									<p class="paragrafo-title">Tráfego gerado</p>
									<p class="paragrafo-subtitle">Quantidade de visitas geradas</p>
									<p class="paragrafo-price-approved">{{add_thousands_sep(affSummaryRaw.views)}}</p>
								</div>
							</div>
						</div>
						<div class="div-container-view">
							<div class="div-container-boxOne">
								<div>
									<p class="paragrafo-title">Vendas pendentes</p>
									<p class="paragrafo-subtitle">Valor de vendas pendentes</p>
									<p class="paragrafo-price-issued">{{to_reais(affSummaryRaw.purchases_issued_value, 2)}}</p>
								</div>
								<div>
									<p class="paragrafo-title">Pedidos pendentes</p>
									<p class="paragrafo-subtitle">Quantidade de pedidos pendentes</p>
									<p class="paragrafo-price-issued">{{add_thousands_sep(affSummaryRaw.purchases_issued_count)}}</p>
								</div>
							</div>
							<div class="div-container-boxTwo">
								<div>
									<p class="paragrafo-title">Comissão pendente</p>
									<p class="paragrafo-subtitle">Valor de comissões pendente</p>
									<p class="paragrafo-price-issued">{{to_reais(affSummaryRaw.purchases_issued_commission, 2)}}</p>
								</div>
								<div>
									<p class="paragrafo-title">Comissões estornadas</p>
									<p class="paragrafo-subtitle">Valor de comissão estornada</p>
									<p class="paragrafo-price-reversal">{{to_reais(affSummaryRaw.reversals_commission, 2)}}</p>
								</div>
							</div>
						</div>
						<div class="div-container-view">
							<div class="div-container-boxOne">
								<div>
									<p class="paragrafo-title">Ticket médio</p>
									<p class="paragrafo-subtitle">Valor médio dos pedidos</p>
									<p class="paragrafo-price-approved">{{to_reais(affSummaryRaw.purchases_approved_avg_value, 2)}}</p>
								</div>
								<div>
									<p class="paragrafo-title">Aprovação dos pedidos</p>
									<p class="paragrafo-subtitle">Taxa de aprovação dos pedidos</p>
									<p class="paragrafo-price-approved">{{formate_percent_value(affSummaryRaw.purchases_approved_rate)}}</p>

								</div>
							</div>
							<div class="div-container-boxTwo">
								<div>
									<p class="paragrafo-title">Ganho por clique (EPC)</p>
									<p class="paragrafo-subtitle">Valor recebido por clique</p>
									<p class="paragrafo-price-approved">{{to_reais(affSummaryRaw.earn_per_click, 3)}}</p>
								</div>
								<div>
									<p class="paragrafo-title">Conversão</p>
									<p class="paragrafo-subtitle">Taxa de conversão (pedidos/tráfego)</p>
									<p class="paragrafo-price-approved">{{formate_percent_value(affSummaryRaw.purchase_view_rate)}}</p>
								</div>
							</div>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap v-else>
					<v-flex xs12 sm12 md12 class="div-loading-circle">
						<v-progress-circular
							indeterminate
						></v-progress-circular>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex sm8 md3>
				<Header
						class="hidden-xs-and-down"
				/>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import dayjs from 'dayjs'
import { affiliate_api } from '@/api'
import Header from '../components/Header.vue'
import DateRangePicker from 'magafilio-vue/components/DateRangePicker'
import SelectPlus from 'magafilio-vue/components/SelectPlus'

export default {
	name: 'Dashboard',
	mixins: [affiliate_api],
	components: {
		Header,
		DateRangePicker,
		SelectPlus,
	},
	data () {
		return {
			loading: false,
			selectedAdvertisers: [],
			affSummaryRaw: {
				purchases_approved_count: 0,
				purchases_approved_value: 0.0,
				purchases_approved_avg_value: 0.0,
				purchases_approved_commission: 0.0,
				purchases_issued_count: 0,
				purchases_issued_value: 0.0,
				purchases_issued_commission: 0.0,
				reversals_count: 0,
				reversals_value: 0.0,
				reversals_commission: 0.0,
				views: 0,
				affiliate_commission_avg: 0,
				purchase_view_rate: 0,
				purchases_approved_rate: 0,
				earn_per_click: 0,
			},
			startDate: dayjs().startOf('day'),
			endDate: dayjs().endOf('day'),
		}
	},
	computed: {
		affiliate: function () {
			return this.$root.affiliate !== {} ? this.$root.affiliate : {}
		},
		advertiserList: function () {
			let advertiserList = this.$root.advertiserList
			if (!Array.isArray(advertiserList) || !advertiserList.length) return []
			return advertiserList
		},
		rootSelectedAdvertisers: function () {
			return (
				(this.$root.selectedAdvertisers &&
					Object.values(this.$root.selectedAdvertisers)) ||
				[]
			)
		},
	},
	methods: {
		date_range_select: function (range) {
			if (this.startDate != range.startDate || this.endDate != range.endDate) {
				this.startDate = range.startDate
				this.endDate = range.endDate
			}
		},
		load_aff_summary: async function() {
			if (this.affiliate._id) {

				this.loading = true

				try {
					// inserindo as lojas selecionadas pelo select
					const advs = this.selectedAdvertisers.reduce(
						(acc, { _id }) => [...acc, _id],
						[]
					)

					let summary = await this.get_summary(this.affiliate._id, {
						start_date: this.startDate.toISOString(),
						end_date: this.endDate.toISOString(),
						advs: advs,
						rnd: Math.random(),
					})

					this.affSummaryRaw = summary.data

				} catch (err) {
					this.$notify({
						type: 'error',
						title: 'Ocorreu um problema, tente novamente mais tarde!',
					})
				}

				this.loading = false
			}
		},
		formate_percent_value: function(value) {
			return value.toFixed(2) + '%'
		},
		add_thousands_sep(x) {
			var parts = x.toString().split(',')
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
			return parts.join(',')
		},
		to_reais: function (value, dec_places) {
			return (
				'R$' +
        this.add_thousands_sep(value.toFixed(dec_places).replace('.', ','))
			)
		},
	},
	watch: {
		startDate: function () {
			this.$root.period.startDate = this.startDate
		},
		endDate: function () {
			this.$root.period.endDate = this.endDate
		},
		selectedAdvertisers: async function () {
			this.$root.selectedAdvertisers = this.selectedAdvertisers
		},
	},
	created: async function () {
		if (
			this.$root.selectedAdvertisers &&
			this.$root.selectedAdvertisers.length
		) {
			this.selectedAdvertisers = this.$root.selectedAdvertisers
		}

		if (this.selectedAdvertisers && this.startDate && this.endDate) {
			await this.load_aff_summary()
		}
	}
}
</script>

<style>

div.dashboard {
	margin: 55px 10px 95px 10px;
}

.div-container-dashboard .div-container-selects {
  margin-top: 25px;
	padding: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.div-container-dashboard .div-container-selects .div-container-filters {
	width: 80%;
	margin-right: 20px;
}

/* begin select de data */
.div-container-dashboard .div-container-selects .div-container-filters  .v-input__prepend-outer {
	margin-top: 12px;
}

.div-container-dashboard .div-container-selects .div-container-filters .v-input__slot {
	padding: 0 12px;
}

.div-container-dashboard .div-container-selects .div-container-filters .v-input__slot .v-text-field__slot {
	padding-top: 5px;
}

.div-container-dashboard .div-container-selects .div-container-filters .v-input__slot .v-label.v-label--active.theme--light {
	top: -2px;
  left: -3px !important;
}

.div-container-selects .v-menu__activator .v-input.v-text-field.v-input--is-label-active.v-input--is-dirty.v-input--is-focused.v-input--is-readonly.theme--light.primary--text .v-input__prepend-outer i
{
	color: #40DA99 !important;
}

.div-container-filters .v-input__icon.v-input__icon--prepend .v-icon.material-icons.theme--light {
	color: #40DA99 !important;
}
/* end select de data  */

/* begin select anunciantes */

.v-menu__content.theme--light.menuable__content__active {
	border-radius: 0px 0px 13px 13px !important;
}

.v-select-list.v-card.theme--light .v-list.theme--light {
	padding: 8px;
}

.div-container-dashboard .div-container-selects .div-container-filters .v-input.v-text-field.v-select.v-input--is-label-active.v-input--is-dirty.theme--light {
	margin-top: 14px;
}

.div-container-dashboard .div-container-selects .div-container-filters .v-chip.v-chip--small.theme--light {
	background: #2D2F32;
	border: 1px solid #c6c6c6;
}

/* end select anunciantes */

/* Begin Botao Gerar relatorio */
.div-container-dashboard .div-container-filters-button button.button-generate-note {
	background: #2D2F32;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 13px;
	margin-right: 10px;
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 12px;
	transform: opacity 0.2s;
}

.div-container-dashboard .div-container-filters-button button.button-generate-note:hover {
	opacity: 0.5;
}

.div-container-dashboard .div-container-filters-button button.button-generate-note p {
	margin: 0px;
	font-size: 14px;
}

.div-container-dashboard .div-container-filters-button button.button-generate-note .v-icon.material-icons-outlined.material-icons.theme--light {
	margin-bottom: 5px;
	color: #40DA99 !important;
}

/* End botão gerara relatorio */


/* Begin loading circle */
.div-container-dashboard .div-loading-circle {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 80vh;
}

.div-container-dashboard .div-loading-circle circle.v-progress-circular__overlay{
	color: #40DA99 !important;
}
/* end loading circle */

/* Begin dashboard */
.div-container-dashboard .div-container-view {
	display: flex;
	align-items: center;
	justify-content: space-between;
	background: #2D2F32;
	margin-top: 15px;
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25);
	border-radius: 13px;
	margin-right: 20px;
	margin-left: 10px;
	padding: 12px 12px 0px 12px;
}

.div-container-dashboard .div-container-view .div-container-boxOne div p.paragrafo-title,
.div-container-dashboard .div-container-view .div-container-boxTwo div p.paragrafo-title {
	font-size: 18px;
	font-weight: 500;
	margin: 0px;
}

.div-container-dashboard .div-container-view .div-container-boxOne div p.paragrafo-subtitle,
.div-container-dashboard .div-container-view .div-container-boxTwo div p.paragrafo-subtitle {
	font-size: 11px;
	margin: 0px 0px 5px 0px;
	opacity: 0.7;
}

.div-container-dashboard .div-container-view .div-container-boxOne div p.paragrafo-price-approved ,
.div-container-dashboard .div-container-view .div-container-boxTwo div p.paragrafo-price-approved {
	font-size: 22px;
	margin-bottom: 25px;
	color: #40DA99 !important;
}

.div-container-dashboard .div-container-view .div-container-boxOne div p.paragrafo-price-issued ,
.div-container-dashboard .div-container-view .div-container-boxTwo div p.paragrafo-price-issued {
	font-size: 22px;
	margin-bottom: 25px;
	color: #5191F2 !important;
}

.div-container-dashboard .div-container-view .div-container-boxTwo div p.paragrafo-price-reversal {
	font-size: 22px;
	margin-bottom: 25px;
	color: #F6851D !important;
}

/* end dashboard */

@media (max-width: 961px){
	.div-container-dashboard {
		margin: auto !important;
		width: 100%;
	}
}

@media (max-width: 800px){
 .div-container-dashboard .div-container-view {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
 }
}

</style>
